import React from 'react';
import {checkoutTextAreaStyle, mobileCheckoutInputStyle} from './styles';
import {withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TBoolean, TText} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {
  getBooleanOrElse,
  getInPojo,
  getString,
  getStringOrElse,
} from '@packages/utilities/data-utils';

const CommerceCheckoutAdditionalTextArea = Atom.createRender(
  ({attributes, classes, context, data, generateAttributes}) => {
    const name = getStringOrElse(getInPojo(data, ['name']), '');
    const placeholder = getString(getInPojo(data, ['placeholder']));

    const required = getBooleanOrElse(getInPojo(data, ['required']), false);
    const isIncluded = context.get('includeTextArea', true);

    return isIncluded ? (
      <textarea
        {...generateAttributes(attributes, classes)}
        name={name}
        placeholder={placeholder}
        maxLength={5000}
        required={required}
      />
    ) : null;
  }
);

const config = createIntegratedAtom({
  displayName: 'Textarea',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Textarea')),
  },
  showEmpty: false,
  style: {
    base: {
      main: checkoutTextAreaStyle,
      tiny: mobileCheckoutInputStyle,
    },
  },
  constraints: {
    ancestors: [
      {is: 'CommerceCheckoutAdditionalInputsContainer', rule: 'ExactlyOne'},
    ],
  },
  render: CommerceCheckoutAdditionalTextArea,
  fields: {
    name: withSystem({label: 'Name', defaultValue: 'Notes'}, TText),
    placeholder: withSystem(
      {label: 'Placeholder', defaultValue: 'Enter notes...'},
      TText
    ),
    required: withSystem({label: 'Required', defaultValue: false}, TBoolean),
  },
});

export default config;
